<template>
  <atomic-logo />

  <div class="items">
    <client-only>
      <bottom-sheet-global-search />
    </client-only>

    <form-input-deposit v-if="isLoggedIn" />

    <div v-if="!isLoggedIn && !isTelegramUser" class="app-header__auth-buttons">
      <button-base type="gray" size="xs" @click="openModalSync(ModalName.SIGN_IN)">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'header.loginButton') }}
      </button-base>

      <button-base type="green" size="xs" @click="openModalSync(ModalName.SIGN_UP)">
        {{ getContent(layoutData, defaultLocaleLayoutData, 'header.registerButton') }}
      </button-base>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ModalName } from '@skeleton/consts/modals';

  const { openModalSync } = useModalStore();

  const profileStore = useProfileStore();
  const { isLoggedIn, isTelegramUser } = storeToRefs(profileStore);

  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);

  const { getContent } = useProjectMethods();
</script>
